import { render, staticRenderFns } from "./uploadAvatar.vue?vue&type=template&id=617e1126&scoped=true&"
import script from "./uploadAvatar.vue?vue&type=script&lang=js&"
export * from "./uploadAvatar.vue?vue&type=script&lang=js&"
import style0 from "./uploadAvatar.vue?vue&type=style&index=0&id=617e1126&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "617e1126",
  null
  
)

export default component.exports